import Layout from '../components/MyLayout.js';
import fetch from 'isomorphic-unfetch';
import BurgerItem from '../components/BurgerItem';
import css from '../sass/sitestyle.scss';
import apiBase from '../utils/apiBase';

const Index = (props) => (
  <Layout {...props}>
    <div className={css.main}>
      <div className={css['page-heading']}>
        <p className={css.eyebrow}>Tried, tested, ranked</p>
        <h1>{props.listTitle}</h1>
        <p>Honest scores from one burger obsession to another.</p>
      </div>
      <div className={css['burger-grid']}>
        {props.mainBurgers.map((burger) => (
          <BurgerItem key={burger.burgerID} burger={burger} />
        ))}
      </div>
    </div>
  </Layout>
);

const sorts = {
  top: 'top/10',
  bottom: 'bottom/10',
};

const getTopBurgers = async () => {
  let topBurgers = await fetch(`${apiBase}/top/10`);
  topBurgers = await topBurgers.json();
  return topBurgers;
};

const getMainBurgers = async (query) => {
  const baseURI = `${apiBase}/`;
  const sortType = query && query.type;
  if (!sortType) {
    return;
  }
  const extension = sorts[sortType];
  if (!extension) {
    return;
  }
  const fullUrl = baseURI + extension;
  console.log('getting main burgers: ', fullUrl);
  let mainBurgers = await fetch(fullUrl);
  mainBurgers = await mainBurgers.json();
  return mainBurgers;
};

Index.getInitialProps = async function({ pathname, query }) {
  const topBurgers = await getTopBurgers();
  let mainBurgers = (await getMainBurgers(query)) || topBurgers;
  console.log(query);
  return {
    topBurgers,
    mainBurgers,
    listTitle: query && query.type === 'bottom' ? 'The bottom of the bun' : 'Burgers worth biting into',
  };
};

export default Index;



// WEBPACK FOOTER //
// pages/index.js